<template>
	<div class="flex items-center border-1 border-gray-200 rounded-lg shadow-sm">
		<div class="flex flex-1 flex-col items-center justify-center border-r-1 border-gray-200 h-32">
			<div class="flex gap-1">
				<span class="text-muted text-2xl font-semibold">Order</span>
				<span
					v-if="order.firstOrder"
					class="flex text-16 items-center gap-1 px-2 rounded-lg text-white bg-success shadow-md"
				>
					New
				</span>
			</div>
			<app-details-shortcut
				class="font-bold text-3xl hover:text-blue-500"
				:identifier="encrypt(order.orderID)"
				:route-name="names.OrderDetails"
			>
				#{{ formatOrderId }}
			</app-details-shortcut>
		</div>
		<div class="flex flex-1 flex-col items-center justify-center border-r-1 border-gray-200 h-32">
			<span class="text-muted text-2xl font-semibold">Value</span>
			<span class="font-bold text-3xl">{{ $filters.formatCurrency(order.total, order.currency) }}</span>
		</div>
		<div
			v-if="
				order['status'] === statuses.pending ||
					order['status'] === statuses.accepted ||
					order['status'] === statuses.pickedUp
			"
			class="flex flex-1 items-center justify-center h-18"
		>
			<CountdownTimer
				:acceptedTime="
					order['status'] === statuses.pending ? order['lastDatePending'] : order['lastDateAccepted']
				"
				:readyTime="order.status === 'PENDING' ? posSettings?.maxPendingMinutes || 3 : order.totalCookingTime"
				:big="true"
			/>
		</div>
	</div>
</template>
<script>
	import AppDetailsShortcut from '@/components/app/AppDetailsShortcut.vue';
	import UtilityService from '@/services/UtilityService';
	import OrderService from '@/services/OrderService';
	import names from '@/router/names';
	import moment from 'moment/moment';
	import orders from '@/constants/orders';
	import mapOrderStatuses, { statuses } from '@/constants/mapOrderStatuses';
	import CountdownTimer from '@/components/orders/CountdownTimer.vue';
	import { mapGetters } from 'vuex';

	export default {
		name: 'SmallOrderDetails',
		components: { CountdownTimer, AppDetailsShortcut },
		props: {
			order: {
				type: Object,
				required: true,
			},
		},
		data: () => ({
			names: names,
			orderStatuses: mapOrderStatuses,
			statuses: statuses,
		}),
		computed: {
			...mapGetters({
				posSettings: 'posSettings',
			}),
			formatOrderId() {
				return OrderService.formatOrderId(this.order.orderID);
			},
			getActiveStatusColor() {
				let orderStatus = this.orderStatuses.find((_status) => _status.value === this.order.status);
				if (orderStatus.value === 'REJECTED') {
					return '';
				}
				return orderStatus.color;
			},
			orderStatus() {
				return this.order.isTakeAwayOrder
					? 'Takeaway'
					: orders.status.find((status) => status.propValue === this.order.status).title;
			},
			statusTime() {
				const attrName = orders.status.find((status) => status.propValue === this.order.status).timeProp;
				return moment(this.order[attrName]).format('HH:mm');
			},
		},
		methods: {
			encrypt(id) {
				return UtilityService.encrypt(id);
			},
		},
	};
</script>
